<template>
  <v-layout row justify-center>
    <CModal :show.sync="dialog" :title="dialogTitle" max-width="400px" scrollable id="master-mainflg-edit-dialog">
        <v-progress-linear v-if="mainFlgProcessing" :style="{ margin: 0 }" :indeterminate="true"></v-progress-linear>
        <v-container fill-height fluid :class="$style['card-container']">
          <v-layout nowrap>
            <v-flex>
              <v-card outlined :class="$style['card-content']">
                <v-card-text :class="$style['card-text']">
                  <div :class="$style.label">グループ名</div>
                  <SelectField
                    v-model="input.group"
                    name="group"
                    label="グループ名"
                    :rules="`required`"
                    :options="selectOptions"
                    :multiple="false"
                    @input="onChangeSelect"
                  />
                  <template v-if="showKeyword">
                    <div>キーワード</div>
                    <RadioField
                      v-model="input.keyword"
                      name="keyword"
                      label="キーワード"
                      :text-key="`keyword`"
                      :value-key="`id`"
                      :options="radioOptions"
                    />
                  </template>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      <template #footer>
        <CButton
          :class="$style['reset-dialog-btn']"
          color="primary"
          @click="submit"
        >
          送信
        </CButton>
      </template>
    </CModal>
  </v-layout>
</template>

<script>
import MyForm from "@/components/form";
import SelectField from "@/components/field/select";
import RadioField from "@/components/field/radio";

export default {
  components: {
    MyForm,
    SelectField,
    RadioField
  },
  props: {
  },
  data() {
    return {
      resourceName: 'masters',
      input: {
        group: null,
        keyword: null
      },
      fields: [
        {
          label: "value",
          name: "keyword",
          rules: "required",
          width: "100%"
        },
        {
          label: "グループ",
          name: "group",
          rules: "required",
          width: "100%"
        },
        {
          label: "メインフラグ",
          name: "representing",
          type: "checkbox",
          textKey: "label",
          valueKey: "value",
          selects: [
            {
              label: "",
              value: 1
            }
          ]
        }
      ]
    };
  },
  watch: {
    dialog(show) {
      if (show) {
        this.$store.dispatch(`${this.resourceName}/list/groups`);
        this.input.group = '---';
        this.$store.commit(`${this.resourceName}/list/resetKeywords`);
      }
    },
    mainFlgProcessing(value) {
      this.handleOverlay(value);
    },
    radioOptions(value) {
      if (value.length) {
        value.forEach((v) => {
          if (v.representing === 1) {
            this.input.keyword = v.id;
          }
        });
      }
    }
  },
  computed: {
    dialog: {
      get() {
        return this.$store.getters[`${this.resourceName}/list/mainFlgOpen`];
      },
      set(value) {
        this.$store.commit(`${this.resourceName}/list/mainFlgClose`);
      }
    },
    mainFlgProcessing() {
      return this.$store.getters[this.resourceName + "/list/mainFlgProcessing"];
    },
    selectOptions() {
      return this.$store.getters[`${this.resourceName}/list/groups`];
    },
    radioOptions() {
      return this.$store.getters[`${this.resourceName}/list/keywords`];
    },
    dialogTitle() {
      return "メインフラグ設定";
    },
    showKeyword() {
      return this.input.group !== '---';
    }
  },
  methods: {
    onChangeSelect(value) {
      this.$store.commit(`${this.resourceName}/list/resetKeywords`);
      if (value !== '---') {
        this.$store.dispatch(`${this.resourceName}/list/keywords`, { group: value });
      }
    },
    async submit() {
      const params = {
        updatedEntity: this.input
      };

      this.$store
        .dispatch(`${this.resourceName}/list/updateMainFlg`, params)
        .then(() => {
          this.dialog = false;
          this.$emit('mainflg-saved');
        })
        .catch(() => {
          if (this.$refs.form) {
            this.$refs.form.setErrors(this.errorMessages);
          }
        });
    },
    handleOverlay(value) {
      if (value) {
        // ローディングマスクを差し込む
        this.$nextTick(() => {
          const overlayHtml = '<div id="master-mainflg-edit-dialog-overlay" class="v-overlay v-overlay--absolute v-overlay--active theme--dark" style="z-index: 5;"><div class="v-overlay__scrim" style="opacity: 0.46; background-color: rgb(33, 33, 33); border-color: rgb(33, 33, 33);"></div><div class="v-overlay__content"><div role="progressbar" aria-valuemin="0" aria-valuemax="100" class="v-progress-circular v-progress-circular--indeterminate" style="height: 64px; width: 64px;"><svg xmlns="http://www.w3.org/2000/svg" viewBox="21.333333333333332 21.333333333333332 42.666666666666664 42.666666666666664" style="transform: rotate(0deg);"><circle fill="transparent" cx="42.666666666666664" cy="42.666666666666664" r="20" stroke-width="2.6666666666666665" stroke-dasharray="125.664" stroke-dashoffset="125.66370614359172px" class="v-progress-circular__overlay"></circle></svg><div class="v-progress-circular__info"></div></div></div></div>';
          const modal = document.getElementById('master-mainflg-edit-dialog');
          if (modal) {
            const contents = modal.getElementsByClassName('modal-content');
            if (contents.length) {
              contents[0].insertAdjacentHTML('beforebegin', overlayHtml);
            }
          }
        });
      } else {
        const overlay = document.getElementById('master-mainflg-edit-dialog-overlay');
        if (overlay) {
          overlay.remove();
        }
      }
    }
  }
};
</script>

<style module lang="scss">
.card-container {
  padding: 0px !important;
  border-bottom: 1px solid #eee;
}
.card-text {
  padding: 10px !important;
}
.card-content {
  overflow-y: auto;
  padding: 8px 0 !important;
  border: none !important;
}
.reset-dialog-btn {
  & > span {
    font-size: 14px !important;
  }
}
.label {
  margin: 10px 0px;
}
</style>
<style lang="scss">
.v-card__title {
  font-size: 14px !important;
}
</style>
<style lang="scss">
#master-mainflg-edit-dialog {
  .modal-dialog {
    max-width: 400px !important;
    .col-sm-4 {
      min-width: 350px !important;
    }
  }
}
</style>

